// src/screens/Admin/AppealManager.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import './AppealManager.css';
import backIcon from '../../assets/backspace-icon.png';

function AppealManager() {
  const [appeals, setAppeals] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAppeals = async () => {
      try {
        const res = await api.get('/admin/appeals');
        setAppeals(res.data);
      } catch (err) {
        console.error('Failed to fetch appeals:', err);
      }
    };

    fetchAppeals();
  }, []);

  return (
    <div className="appeal-manager">
      <div className="appeal-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="appeal-back-icon"
          onClick={() => navigate('/admin')}
        />
        <h2>Submitted Appeals</h2>
      </div>

      <div className="appeal-scroll-area">
        {appeals.map((appeal) => (
          <div
            key={appeal._id}
            className="appeal-card"
            onClick={() => navigate(`/admin/appeals/${appeal._id}`)}
          >
            <p><strong>Username:</strong> {appeal.username}</p>
            <p><strong>Role:</strong> {appeal.role}</p>
            <p><strong>Appeal Date:</strong> {new Date(appeal.createdAt).toLocaleString()}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AppealManager;
